// The parser service serves uploaded files under its own /parser path prefix,
// so relative paths like "/resumes/<id>.pdf" returned by the parser must be
// resolved against the parser base, not the bare origin. Without this, the
// browser treats /resumes/<id>.pdf as an SPA route, doesn't match any
// <Route>, and the catch-all in App.js redirects the user to "/".
export const RESUME_SERVER_BASE = "https://phone.getscreened.in/parser";

export const buildResumeURL = (raw) => {
  if (!raw) return null;
  const trimmed = String(raw).trim();
  if (!trimmed) return null;
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) return trimmed;
  if (trimmed.startsWith("/")) return `${RESUME_SERVER_BASE}${trimmed}`;
  return `${RESUME_SERVER_BASE}/${trimmed}`;
};
